import { render } from "./PaymentBatch.vue?vue&type=template&id=390400f7&scoped=true"
import script from "./PaymentBatch.vue?vue&type=script&lang=js"
export * from "./PaymentBatch.vue?vue&type=script&lang=js"

import "./PaymentBatch.vue?vue&type=style&index=0&id=390400f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390400f7"]])

export default __exports__